import axios from "axios";
import { API_IP } from "../env";
// Set your API's base URL
const API_URL = `${API_IP}/api`;

// Helper function to get the auth header
const getAuthHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

/**
 * Gets all bookings from the admin endpoint
 *
 */
export const getAdminBookings = (token, page = 1, limit = 15, search = "") => {
  // Add search as a query parameter
  return axios.get(
    `${API_URL}/admin?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`,
    getAuthHeaders(token)
  );
};

/**
 * Gets all providers from the admin endpoint
 *
 */
export const getAllProviders = (token) => {
  return axios.get(`${API_URL}/admin/providers`, getAuthHeaders(token));
};

/**
 * Gets full detail for a single provider
 */
export const getProviderDetail = (token, provider_id) => {
  return axios.get(
    `${API_URL}/admin/providers/${provider_id}/detail`,
    getAuthHeaders(token)
  );
};

/**
 * Updates a booking's provider
 *
 */
export const updateBookingProvider = (token, booking_id, provider_id) => {
  const payload = {
    booking_id,
    provider_id, // This will trigger the provider change logic
  };
  return axios.patch(`${API_URL}/admin`, payload, getAuthHeaders(token));
};

/**
 * Confirms or Unconfirms a booking on behalf of a provider
 *
 * @param {string} token - Admin JWT
 * @param {string} booking_id - The booking to update
 * @param {boolean} acceptanceStatus - true to confirm, false to unconfirm
 */
export const updateBookingConfirmation = (
  token,
  booking_id,
  acceptanceStatus
) => {
  const payload = {
    booking_id,
    acceptanceStatus, // This will trigger the acceptance logic
  };
  return axios.patch(`${API_URL}/admin`, payload, getAuthHeaders(token));
};

/**
 * TestFlight: list beta testers for the configured app.
 */
export const getTestFlightTesters = (token, search = "") => {
  return axios.get(`${API_URL}/admin/testflight/testers`, {
    params: { search },
    ...getAuthHeaders(token),
  });
};

/**
 * TestFlight: list beta groups for the configured app.
 */
export const getTestFlightGroups = (token) => {
  return axios.get(
    `${API_URL}/admin/testflight/groups`,
    getAuthHeaders(token)
  );
};

/**
 * TestFlight: invite a new beta tester to a group.
 * @param {object} payload - { firstName, lastName, email, groupId }
 */
export const inviteTestFlightTester = (token, payload) => {
  return axios.post(
    `${API_URL}/admin/testflight/testers`,
    payload,
    getAuthHeaders(token)
  );
};

/**
 * TestFlight: resend the TestFlight invitation email to an existing tester.
 */
export const resendTestFlightInvite = (token, testerId) => {
  return axios.post(
    `${API_URL}/admin/testflight/testers/${testerId}/resend`,
    {},
    getAuthHeaders(token)
  );
};

/**
 * TestFlight: delete a beta tester from the app.
 */
export const deleteTestFlightTester = (token, testerId) => {
  return axios.delete(
    `${API_URL}/admin/testflight/testers/${testerId}`,
    getAuthHeaders(token)
  );
};
